import { enumNarrow } from '../helpers/enumGuard'

export enum AuthProvider {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft',
  PASSWORD = 'password',
}

export interface IGoogleTokenPayload {
  sub: string // Google user ID
  email: string
  given_name?: string
  family_name?: string
  picture?: string
  email_verified: boolean
}

export interface IMicrosoftTokenPayload {
  sub: string
  email: string
  name?: string
  given_name?: string
  family_name?: string
  picture?: string
  preferred_username: string
  email_verified?: boolean
  oid?: string
}

export interface ITwoFactorSetupData {
  qrCodeDataURL?: string
  manualEntryKey?: string
  backupCodes?: string[]
  tempSecret?: string
}

export interface ITwoFactorEnableData {
  success?: {
    message: string
  }
  twoFactorEnabled: boolean
  enabledAt: Date
}

export interface ITwoFactorVerifyData {
  jwt: string
  user: {
    id: string
    email: string
    firstName: string
    lastName: string
    role: string
    twoFactorEnabled: boolean
  }
  backupCodesRemaining: number
}

export interface ITwoFactorDisableData {
  success?: {
    message: string
  }
  twoFactorEnabled: boolean
}

export enum AuthError {
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  INVALID_EMAIL_OR_PASSWORD = 'INVALID_EMAIL_OR_PASSWORD',
  NOT_ACTIVE_USER = 'NOT_ACTIVE_USER',
  ACCOUNT_ALREADY_LINKED = 'ACCOUNT_ALREADY_LINKED',
  ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
  INVITATION_EXPIRED = 'INVITATION_EXPIRED',
  NO_BACKUP_CODES = 'NO_BACKUP_CODES',
  INVALID_2FA_CODE = 'INVALID_2FA_CODE',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
}

/** Cast-free narrower for AuthError (see common/helpers/enumGuard). */
export const asAuthError = enumNarrow(AuthError).as
